'use strict';

function LoanOffersLevelUp() {
  var _this3 = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._moneyOfferPath = 'money.offers.offers[0]';

  this._$elem = {
    learnMoreCta: '.js--learn-more',
    learnMoreContainer: '.js--learn-more-component',
    learnMoreDrawer: '.js--learn-more-drawer',
    liveChatBtn: '.js--live-chat-cta'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    var _this = this;

    this._$node = $(this.node);

    this._$learnMoreCta = $(this.node).find(this._$elem.learnMoreCta);
    this._$learnMoreContainer = $(this.node).find(this._$elem.learnMoreContainer);
    this._$learnMoreDrawer = $(this.node).find(this._$elem.learnMoreDrawer);

    // Set up Offer Variables
    this._offerData = this._activeOffer.getOfferData();
    this._offerIsPaused = this._activeOffer.isOfferPaused();
    this._offerPayments = this._activeOffer.getOfferPayments();
    this._offerApr = this._activeOffer.getOfferApr();
    this._offerTerm = this._activeOffer.getOfferTermInPreferredUnits();
    this._offerName = this._activeOffer.getOfferName();
    this._offerType = this._activeOffer.getOfferType();
    this._displayOffer();
    this._setComputedVariables();

    mogo.ready(function () {
      _this._createDrawer();
      _this._createDisclaimer();

      // chat now cta when offer is paused
      if (_this._offerIsPaused) {
        _this._setupLiveChat();
      }
    });

    this._pushAnalytics();
  };

  this._pushAnalytics = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this.destroy = function () {
    this.presenter.removeComputedVariable('offerAmount');
    this.presenter.removeComputedVariable('formattedOfferAmount');
    this.presenter.removeComputedVariable('loanEffectiveBalance');
    this.presenter.removeComputedVariable('loanAmountRemaining');
    this.presenter.removeComputedVariable('offerPayments');
    this.presenter.removeComputedVariable('offerTerm');
    this.presenter.removeComputedVariable('offerApr');
    this.presenter.removeComputedVariable('isOfferPaused');

    this._super();
  };

  this._setComputedVariables = function () {
    var _this2 = this;

    // is_paused value from active offer
    this.presenter.addComputedVariable('isOfferPaused', ['money.offers'], function (val) {
      if (_this2._offerData) {
        return _this2._activeOffer.isOfferPaused() || '';
      }
    });

    // OfferAmount
    this.presenter.addComputedVariable('offerAmount', [this._liquidLoanPath + '.amount'], function (val) {
      return _this2._activeOffer.getOfferAmount();
    });

    this.presenter.addComputedVariable('formattedOfferAmount', [this._liquidLoanPath + '.amount'], function (val) {
      return Formatters.formatMoney(_this2._activeOffer.getOfferAmount(), { optionalDecimals: true });
    });

    // Effective Balance: principal.amount_remaining - (next_payment.amount + next_payment.lp)
    this.presenter.addComputedVariable('loanEffectiveBalance', [this._liquidLoanPath + '.effective_balance'], function (eb) {
      var result = 0;
      if (eb != null) {
        result = _this2._activeOffer.getOfferAmount() - eb; // Offer - Effective balance.
      }
      return Formatters.formatMoney(result);
    });

    // amount of Level up less the (remaining + junk).
    // TODO: make Loan Class?
    this.presenter.addComputedVariable('loanAmountRemaining', [this._liquidLoanPath + '.effective_balance'], function (eb) {
      var result = 0;
      if (eb != null) {
        result = eb;
      }
      return Formatters.formatMoney(result);
    });

    // Bi Weekly Payments
    this.presenter.addComputedVariable('offerPayments', [this._moneyOfferPath + '.amount'], function (val) {
      return _this2._offerPayments.biweekly;
    });

    // Offer Term
    this.presenter.addComputedVariable('offerTerm', [this._moneyOfferPath + '.terms'], function (val) {
      return _this2._offerTerm;
    });

    this.presenter.addComputedVariable('offerApr', [this._moneyOfferPath + '.apr'], function (val) {
      return _this2._offerApr;
    });
  };

  this._displayOffer = function () {
    var wrapperClass = _this3._isEligibleForLoanProduct() ? 'is-' + _this3._offerName : null;

    if (wrapperClass) {
      if (_this3._offerType === 'enhanced') {
        wrapperClass += '-enhanced';
      }
    }
    _this3._$node.addClass(wrapperClass);
  };

  this._createDrawer = function () {
    // Exists in level up view only
    if (_this3._$learnMoreDrawer.length) {
      _this3._$learnMoreDrawer.mogo().create('Drawer', {
        expanded: -1,
        autoCollapse: false,
        onClick: function (e) {
          if ($(this._$learnMoreContainer).attr('aria-expanded') === 'true') {
            $(e.target).text('Less info');
          } else if ($(this._$learnMoreContainer).attr('aria-expanded') === 'false') {
            $(e.target).text('More info');
          }
        }.bind(_this3)
      });
    }
  };

  // Legal Disclaimer:
  this._createDisclaimer = function () {
    var legal = $('.js--legal-disclaimer', this._$node);
    var legalElem = '[data-legal]:visible';
    var displayedOfferName = this._isEligibleForLoanProduct() ? '.show-for-' + this._offerName : null;
    if (displayedOfferName) legalElem = legalElem + ', [data-legal]' + displayedOfferName;

    // Init all the visibile disclaimers + the product ones that are hidden (learn more)
    if (legal.length) {
      legal.mogo().create('LegalDisclaimer', {
        legal: $(legalElem, this._$node),
        presenter: this.presenter
      });
    } else {
      console.error('DashboardMoney.js: Missing  element on page.');
    }
  };

  this._setupLiveChat = function () {
    // scope variables because elements might not be visible yet
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");
    this._$liveChat = $('.js--live-chat');
    this._$chatBtn = $(this._$elem.liveChatBtn);

    // Prevents LiveChat from creating another component IE LiveChat_1
    // Behavior: Hide Chatbubble unless they click a chat bubble CTA
    if (this._$chatBtn.length > 0 && this._liveChatComponent.length === 0) {
      this._$liveChat.mogo().create('LiveChat', {
        presenter: this.presenter
      });
    } else if (this._liveChatComponent.length) {
      this._liveChatComponent.mogo().hideChatIfNotEngaged();
    }

    this._$chatBtn.on('click', function (e) {
      e.preventDefault();
      if (window.LC_API && window.LC_API.open_chat_window) window.LC_API.open_chat_window();
    });
  };
}